import { render } from "./ProfileSettingsLocation.vue?vue&type=template&id=1b7d32c4&ts=true"
import script from "./ProfileSettingsLocation.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__